import Image from 'next/image';
import { useEffect } from 'react';
import { ToastStyle } from '../../../styles/components/common/ui';
export interface IToastProps {
  children: React.ReactNode;
  type: 'success' | 'danger' | 'neutral' | 'warning';
  icon?: React.ReactElement;
  show?: boolean;
  dismissable?: boolean;
  dismissTimeout?: number;
  onDismiss: () => void;
}

const Toast = (props: IToastProps) => {
  useEffect(() => {
    if (props.show === true && !props.dismissable) {
      setTimeout(() => {
        props.onDismiss();
      }, props.dismissTimeout ?? 3000);
    }
  }, [props, props.show]);

  if (props.show) {
    return (
      <div
        className={`${ToastStyle['toast']} ${ToastStyle[props.type]} ${
          ToastStyle['animate-in']
        } ${props.dismissable ? ToastStyle['is-dismissable'] : ''} ${
          props.icon ? ToastStyle['has-icon'] : ''
        }`}>
        {props.icon && (
          <div className={ToastStyle['toast-icon']}>{props.icon}</div>
        )}
        <div className={ToastStyle['toast-content']}>{props.children}</div>
        {props.dismissable && (
          <Image
            src={'/assets/images/icons/CloseIcon.svg'}
            className={ToastStyle['toast-dismiss']}
            alt="Close"
            width={24}
            height={24}
            onClick={() => props.onDismiss()}
          />
        )}
      </div>
    );
  } else {
    return null;
  }
};

export default Toast;
